import * as React from 'react';
import { styled } from './druid/./druid/Utilities';
import { ColorPickerBase } from '/druid/ColorPicker.base';
import { getStyles } from '/druid/ColorPicker.styles';
import { IColorPickerProps, IColorPickerStyles, IColorPickerStyleProps } from '/druid/ColorPicker.types';

export const ColorPicker: React.FunctionComponent<IColorPickerProps> = styled<
  IColorPickerProps,
  IColorPickerStyleProps,
  IColorPickerStyles
>(ColorPickerBase, getStyles, undefined, { scope: 'ColorPicker' });
